import { motion } from "framer-motion";

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5 },
};

const sections = [
  {
    title: "AI Document Processing",
    items: [
      "Intelligent data extraction",
      "Document classification",
      "Support for PDFs, images, and scanned files",
    ],
  },
  {
    title: "Automation",
    items: [
      "Automated workflows",
      "Data validation and formatting",
      "Event-based processing",
    ],
  },
  {
    title: "Integrations",
    items: [
      "APIs for custom workflows",
      "Cloud storage integrations",
      "Export to databases and enterprise systems",
    ],
  },
  {
    title: "Security",
    items: [
      "Secure document processing",
      "Role-based access control",
      "Audit trails and activity logs",
    ],
  },
];

export default function CoreCapabilities() {
  return (
    <section className="section-padding bg-[#f6f8fb]">
      {/* ✅ ONLY CHANGE → wrap inside container-width */}
      <div className="container-width">
        {/* Heading */}
        <motion.div className="max-w-3xl mb-16" {...fadeInUp}>
          <h2
            className="text-3xl md:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950 mb-6"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Core Capabilities Included Across Plans
          </h2>

          <p className="text-lg md:text-xl leading-relaxed text-neutral-600">
            All Bridge Format AIQ plans include powerful AI document
            intelligence features.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-[4px] p-6 border border-gray-200 shadow-sm hover:shadow-md transition"
              initial="initial"
              whileInView="whileInView"
              viewport={{ once: true }}
              variants={fadeInUp}
              transition={{ delay: index * 0.1 }}
            >
              <h3
                className="text-lg font-semibold text-[#006fa0] mb-4"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                {section.title}
              </h3>

              <ul className="space-y-3 text-sm text-neutral-600">
                {section.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <span className="text-[#00bdef] mt-[2px]">✔</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
